import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllGrades() {
  return get(`${apiHost}/api/teacher/grades`);
}
